import axios from "axios";
import { setupInterceptors } from "./interceptors";
export const normalizeBaseURL = (value) => {
    if (!value)
        return value;
    const v = String(value).trim();
    if (/^(https?:)?\/\//i.test(v))
        return v.replace(/\/+$/, "");
    const withSlash = v.startsWith("/") ? v : `/${v}`;
    return withSlash.replace(/\/+$/, "");
};
export const getBaseURL = () => {
    if (process.env.VUE_APP_API_BASE_URL) {
        return normalizeBaseURL(process.env.VUE_APP_API_BASE_URL);
    }
    // vue-cli / nginx: same-origin `/api` (proxy → Flask). Port bağımsız çalışır.
    const port = typeof window !== "undefined" ? window.location.port : "";
    if (process.env.NODE_ENV === "development" ||
        port === "8080" ||
        port === "8081" ||
        port === "80" ||
        port === "") {
        return "/api";
    }
    return "http://localhost:5000/api";
};
const api = axios.create({
    baseURL: getBaseURL(),
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 1800000,
});
setupInterceptors(api);
export default api;
